export const navigationItems = [
  { href: '#hero', label: 'Accueil' },
  { href: '#about', label: 'À propos' },
  { href: '#skills', label: 'Compétences' },
  { href: '#timeline', label: 'Expériences' },
  { href: '#contact', label: 'Contact' },
];
